export function ErrorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="73"
      viewBox="0 0 65 73"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M0.5 16C0.5 7.16344 7.66344 0 16.5 0H48.5C57.3366 0 64.5 7.16344 64.5 16V48C64.5 56.8366 57.3366 64 48.5 64H16.5C7.66344 64 0.5 56.8366 0.5 48V16Z"
        fill="#0D1207"
      />
      <path
        d="M0.5 16C0.5 7.16344 7.66344 0 16.5 0H48.5C57.3366 0 64.5 7.16344 64.5 16V48C64.5 56.8366 57.3366 64 48.5 64H16.5C7.66344 64 0.5 56.8366 0.5 48V16Z"
        fill="url(#paint0_radial_8829_93080)"
        fillOpacity="0.2"
      />
      <path
        d="M16.5 0.5H48.5C57.0604 0.5 64 7.43959 64 16V48C64 56.5604 57.0604 63.5 48.5 63.5H16.5C7.93959 63.5 1 56.5604 1 48V16C1 7.43959 7.93959 0.5 16.5 0.5Z"
        stroke="url(#paint1_linear_8829_93080)"
        strokeOpacity="0.16"
      />
      <g filter="url(#filter0_d_8829_93080)">
        <path
          opacity="0.9"
          d="M16 40.5645L40.8567 15.7078C41.2472 15.3172 41.8804 15.3172 42.2709 15.7078L48.6496 22.0865C49.0401 22.477 49.0401 23.1102 48.6496 23.5007L24.5 47.6503C24.1095 48.0408 23.4763 48.0408 23.0858 47.6503L16 40.5645Z"
          fill="#FF8A66"
        />
        <path
          opacity="0.9"
          d="M41.564 48.3574L16.7073 23.5007C16.3168 23.1102 16.3168 22.4771 16.7073 22.0865L23.086 15.7078C23.4765 15.3173 24.1097 15.3173 24.5002 15.7078L48.6498 39.8574C49.0403 40.2479 49.0403 40.8811 48.6498 41.2716L41.564 48.3574Z"
          fill="#FF8A66"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_8829_93080"
          x="0"
          y="7.41406"
          width="64.9429"
          height="64.9434"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0 0.027451 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8829_93080"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8829_93080"
            result="shape"
          />
        </filter>
        <radialGradient
          id="paint0_radial_8829_93080"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.5) rotate(45) scale(90.5097)"
        >
          <stop stopColor="#FF6333" />
          <stop offset="1" stopColor="#330C00" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_8829_93080"
          x1="31.9839"
          y1="31.4839"
          x2="5.66129"
          y2="5.16129"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0D1207" />
          <stop offset="1" stopColor="#F3F8ED" />
        </linearGradient>
      </defs>
    </svg>
  );
}
